import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import app from "./firebase";
import styles from "./IngredientUsageIndexDashboard.module.css";
import { format2 } from "./utils/format2";

const db = getFirestore(app);

export default function IngredientUsageIndexDashboard() {
  const navigate = useNavigate();
  const [ingredients, setIngredients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const snap = await getDocs(collection(db, "ingredients"));
        const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setIngredients(rows);
      } catch (err) {
        console.error("Error fetching ingredients:", err);
        setIngredients([]);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return ingredients;
    return ingredients.filter(i => (i.name || "").toLowerCase().includes(term));
  }, [ingredients, search]);

  if (loading) return <p className={styles.loading}>Loading ingredients...</p>;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Ingredient Usage</h2>
      </div>

      <div className={styles.controls}>
        <input
          className={styles.searchInput}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search ingredients..."
        />
      </div>

      <div className={styles.list}>
        {filtered.map(i => (
          <button
            key={i.id}
            className={styles.row}
            onClick={() => navigate(`/ingredient-usage/${i.id}`)}
            title="View ingredient usage"
          >
            <span className={styles.name}>{i.name || "(Unnamed ingredient)"}</span>
            <span className={styles.meta}>{format2(i.currentStock ?? 0)} {i.unit || ""}</span>
            <span className={styles.chevron}>→</span>
          </button>
        ))}
        {filtered.length === 0 && <div className={styles.empty}>No ingredients found</div>}
      </div>
    </div>
  );
}
